export default defineNuxtRouteMiddleware((to) => {
  const token = useState('token')
  const tokenFromQuery = to.query.token as string | undefined

  // 如果URL中有code，更新状态中的code（URL中的code优先级最高）
  if (tokenFromQuery) {
    token.value = tokenFromQuery
  }

  // 如果URL中有token，且目标路由不是unauthorized页面，则需要携带token
  if (token.value && to.path !== '/unauthorized') {
    if (!to.query.token) {
      return navigateTo({
        path: to.path,
        query: {
          ...to.query,
          token: token.value,
        },
        hash: to.hash,
      }, {
        replace: true,
      })
    }
  }
}) 